/* eslint-disable camelcase */
import BigTitleBox from '@/molecules/titles/BigTitleBox';
import TitleBox from '@/molecules/titles/TitleBox';
import getCtaProps from 'utils/cms/getCtaProps';
import { CMSCallToActionType } from 'utils/cms/types';

type Props = { title: string; subtitle: string; title_variant: 'MainTitle' | 'TitleBox'; cta?: CMSCallToActionType };

const NewTitle = ({ title, subtitle, title_variant, cta }: Props) =>
  title_variant === 'MainTitle' ? (
    <BigTitleBox subtitle={subtitle}>{title}</BigTitleBox>
  ) : (
    <TitleBox buttonProps={getCtaProps(cta)}>{title}</TitleBox>
  );

export default NewTitle;
